export enum AUTH {
  USER = 'ROLE_USER',
  MANAGER = 'ROLE_MANAGER',
  ADMIN = 'ROLE_ADMIN',
  MASTER = 'ROLE_MASTER',
}
